export const DRAFT_ORDER_CONTAINER_TO_PRINT = 'draftOrderContainerToPrint';
